import React from 'react';
import moment from 'moment';

class JobFullDetailsInternalJobNote extends React.Component {
  render() {
    const { note, id, childJobId, parentJobId, jobType, fullName, createdAt, handleDeleteNote } = this.props;

    let notejson = note.modifications ? JSON.parse(note.modifications) : "";
    let splitjson = note.split ? JSON.parse(note.split) : false;
    let parentjson = note.parent ? JSON.parse(note.parent) : false;
    let subcontracted = note.subcontracted ? JSON.parse(note.subcontracted) : false;
    return (
      <div className="row" id={"selector-note-" + id}>
        <div className="col-md-9">
          <div className="d-flex align-items-center">
            <textarea rows="4" className="form-control form-control-lg mr-2" id={"note-row-" + id} defaultValue={notejson.note || ''} readOnly={true}></textarea>
            <a onClick={() => handleDeleteNote(id, notejson.note)} className='btn'>
              <i className="fa fa-trash fa-2x text-danger"></i>
            </a>
          </div>
          <small hidden={!splitjson}><strong>Message from Split job </strong><i><a target="_blank" href={"/jobs/view/" + childJobId}>{jobType}</a></i></small>
          <small hidden={!parentjson}><strong>Message from Parent job </strong><i><a target="_blank" href={"/jobs/view/" + parentJobId}>{jobType}</a></i></small>
          <small hidden={!subcontracted}><strong>Message from Subbed job </strong><i><a target="_blank" href={"/jobs/view/" + childJobId}>{jobType}</a></i></small>
          <br />
        </div>
        <div className="col-md-3 my-3">
          <span className="d-flex flex-column"><strong>{fullName}</strong><i>{moment(createdAt).format('DD/MM/YYYY HH:mm:ss')}</i></span>
        </div>
      </div>
    );
  }
}

export default JobFullDetailsInternalJobNote;
